// extracted by mini-css-extract-plugin
module.exports = {"loading":"image_loading__3_NqH","loaded":"image_loaded__2kBhP","fadeIn":"image_fadeIn__3Ld_5","fadeOut":"image_fadeOut__3IpfC"};